﻿import { HttpHelper } from "../helper/http-helper-service";
import PrototypeInstance from "../helper/prototype-instance";
import { constants } from "../constant/constants";
import {
  FormRequestModel,
  FormSubmissionEmailModel,
} from "../model/form/form-model";
import { formEntity } from "../model/entity/form-entity";

import api from "../Axios/axios";

export default class formService {
  static createShareableLink(object: any) {
    return HttpHelper.postData(
      constants.apiUrl.formUrls.createShareableLink,
      object,
    );
  }

  static getFormList() {
    return HttpHelper.getData(constants.apiUrl.formUrls.getFormList);
  }

  static getFormContentByFormId(formId: string) {
    return HttpHelper.getData(
      constants.apiUrl.formUrls.getFormContentByFormId.replace("{id}", formId),
    );
  }

  static async getFormById(formId: string) {
    let clientId =
      PrototypeInstance.globalProperties.$store.getters[
        "ContactModule/getClientId"
      ];

    let form: formEntity = await HttpHelper.getData(
      constants.apiUrl.formUrls.getFormById.replace("{id}", formId),
    );

    if (
      form.allowInPortal &&
      (!form.clientIds === null ||
        form.clientIds.length === 0 ||
        form.clientIds.includes(clientId))
    ) {
      return form;
    } else {
      formEntity.delete((form) => {
        return form.id == formId;
      });
    }
  }

  //Form Drafts
  static getFormDraftList(createdByContactId: number) {
    let testUrl: string = constants.apiUrl.formUrls.getFormDraftList.replace(
      "{createdById}",
      createdByContactId.toString(),
    );
    return HttpHelper.getData(testUrl);
  }

  static getFormDraftContentByFormId(formId: string) {
    return HttpHelper.getData(
      constants.apiUrl.formUrls.getFormDraftContentByFormId.replace(
        "{id}",
        formId,
      ),
    );
  }

  static createFormDraft(object: FormRequestModel) {
    return HttpHelper.postData(constants.apiUrl.formUrls.createForm, object);
  }

  static updateFormDraft(object: FormRequestModel) {
    return HttpHelper.patchData(constants.apiUrl.formUrls.updateForm, object);
  }
  //End Form Drafts
  static async submitForm(object: any) {
    const response = await api.post<any>(
      constants.apiUrl.PublicFunctionsUrls.sendFormResponse,
      object,
    );
    return response.data;
  }

  static deleteForm(formId: string) {
    return HttpHelper.deleteData(
      constants.apiUrl.formUrls.deleteFormDraft.replace("{id}", formId),
      {},
    );
  }

  static sendFormEmail = async (
    emailModel: FormSubmissionEmailModel,
    header: any,
  ) => {
    if (header) {
      api.interceptors.request.use((config) => {
        const herderValue: string =
          PrototypeInstance.globalProperties.$store.getters[
            "MasterModule/getFormEmailKey"
          ];
        config.headers["emailKey"] = herderValue;
        return config;
      });
    }

    const response = await api.post<boolean>(
      constants.apiUrl.PublicFunctionsUrls.sendFormEmail,
      emailModel,
    );
    return response.data;
  };
}
